export default __webpack_public_path__ + "static/media/notificationIcon.7a2ae1b8.svg";